import React from 'react'


function Press() {
  return (
<div className="Press">

</div>
  )
}

export default Press